import React, { FC, useContext } from 'react';
import { CustomInput, ListDropDown } from 'components';
import { CreateEditEstimateNavEnum } from 'containers/estimates/constants';
import { CreateEstimateContextType } from 'containers/estimates/types';
import { CreateEstimateContext } from '../CreateEstimate';
import { useAppDispatch, useAppSelector } from 'hooks';
import {
  selectLeadSource,
  selectLeadSourceType,
  updateLeadSource,
  updateLeadSourceType
} from 'containers/estimates/estimatesSlice';
import { LeadSource, LeadSourceOptions } from 'containers/jobs/constant';

const EstimateLeadSource: FC = () => {
  const { setSelectedEstimateTab } = useContext<CreateEstimateContextType>(CreateEstimateContext);
  const dispatch = useAppDispatch();

  const selectedLeadSourceType = useAppSelector(selectLeadSourceType);
  const selectedLeadSource = useAppSelector(selectLeadSource);

  const handleLeadSourceTypeChange = value => {
    dispatch(updateLeadSourceType(value));
    dispatch(updateLeadSource(''));
    setSelectedEstimateTab(CreateEditEstimateNavEnum.MORE_OPTIONS);
  };

  const handleLeadSourceChange = value => {
    dispatch(updateLeadSource(value));
    setSelectedEstimateTab(CreateEditEstimateNavEnum.MORE_OPTIONS);
  };

  const showLeadInputField =
    selectedLeadSourceType?.id === LeadSource.REFERRAL || selectedLeadSourceType?.id === LeadSource.OTHER;

  return (
    <div>
      <div className={'mb-2 text-17px font-semibold'}>Lead Source</div>

      <div className="flex gap-5">
        <div className="w-1/2">
          <ListDropDown
            id="lead-source-dropdown"
            items={LeadSourceOptions}
            selectedItem={selectedLeadSourceType}
            setSelectedItem={handleLeadSourceTypeChange}
            buttonStyles="bg-secondaryBtn h-[50px] text-[17px] font-semibold text-primaryText cursor-pointer pl-5"
            placeholder="Choose lead source"
            spanStyles={`font-normal text-[17px] leading-[21px] ${
              selectedLeadSourceType ? 'text-primaryText' : 'text-accentText opacity-70'
            }`}
            itemStyle="font-normal text-[17px] tracking-[-0.3px] leading-[28px]"
          />
        </div>
        <div className="w-1/2">
          {showLeadInputField && (
            <CustomInput
              id="lead-source-input"
              onChange={handleLeadSourceChange}
              placeholder={
                selectedLeadSourceType.id === LeadSource.REFERRAL ? 'Enter referrer name' : 'Enter lead source'
              }
              value={selectedLeadSource}
              className="mt-1 px-5 text-[17px] font-normal leading-5 outline-none placeholder:text-[17px]"
              inputStyle=""
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EstimateLeadSource;
